<!-- 获取车辆屏显及语音接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {

           "parkCode": "2KPJZECG",
       "channelCodeList":["222"],
       "carCode":"粤A00001",
       "vipType":1
        },
        responseCode: {
          "data": {
            "parkCode": "2KNTYVWC",
            "eptCarports": "111"
          },
          "message": "业务成功",
          "resultCode": 0,
          "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台获取车辆屏显及语音",
          t_url: this.commonUrls.test + "getDisplayVoiceByCarCode",
          p_url: this.commonUrls.prod + "getDisplayVoiceByCarCode",
          precondition: "无",
          fitSystem: "VEMS传统停车场, 云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{
              tableHead: '参数名',
              tdName: 'info1'
            }, {
              tableHead: '是否必填',
              tdName: 'info2'
            }, {
              tableHead: '类型',
              tdName: 'info3'
            }, {
              tableHead: '说明',
              tdName: 'info4'
            }],
            td: [{
                info1: 'parkCode',
                info2: '是',
                info3: 'String',
                info4: '停车场编号'
              },
              {
                  info1: 'carCode',
                  info2: '是',
                  info3: 'String',
                  info4: '车牌号'
                },
              {
                info1: 'channelCodeList',
                info2: '是',
                info3: 'JSONArray',
                info4: '通道编码列表'
              },
              {
                info1: 'vipType',
                info2: '是',
                info3: 'Integer',
                info4: 'vip类型(1临时车，2本地vip，5访客车辆，8白名单)'
              }, {
                info1: 'featurePassTime',
                info2: '否',
                info3: 'String',
                info4: '预计通行时间(yyyyMMddHHmmss)'
              },  {
                info1: 'whetherCharge',
                info2: '否',
                info3: 'Integer',
                info4: '是否收费(0：否，1：是)，默认为0'
              }
            ]
          }],
          R_params: [{
              titleName: null,
              tabledata: [{
                tableHead: '参数名',
                tdName: 'info1'
              }, {
                tableHead: '是否必填',
                tdName: 'info2'
              }, {
                tableHead: '类型',
                tdName: 'info3'
              }, {
                tableHead: '说明',
                tdName: 'info4'
              }],
              td: [{
                info1: 'list',
                info2: '否',
                info3: 'jsonArray',
                info4: '获取车辆显屏和语音列表'
              }]
            }, {
              titleName: 'list',
              tabledata: [{
                tableHead: '参数名',
                tdName: 'info1'
              }, {
                tableHead: '是否必填',
                tdName: 'info2'
              }, {
                tableHead: '类型',
                tdName: 'info3'
              }, {
                tableHead: '说明',
                tdName: 'info4'
              }],
              td: [{
                  info1: 'display',
                  info2: '是',
                  info3: 'String',
                  info4: '显屏'
                },
                {
                  info1: 'voice',
                  info2: '是',
                  info3: 'String',
                  info4: '语音'
                },
                {
                  info1: '通道编码',
                  info2: '是',
                  info3: 'String',
                  info4: '通道编码'
                }
              ]
            }


          ],
          codeStatus: [{
            titleName: null,
            tabledata: [{
              tableHead: '状态码',
              tdName: 'info1'
            }, {
              tableHead: '说明',
              tdName: 'info2'
            }],
            td: [{
              info1: '000110',
              info2: '失败',
            }, {
              info1: '00110000',
              info2: '失败',
            }, {
              info1: '110000',
              info2: '失败',
            }]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/park/getDisplayVoiceByCarCode.vue